import React, { useState, useEffect, Suspense, useContext, useRef } from 'react';
import { Link, NavLink, useLocation,useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import OwlCarousel from "react-owl-carousel3";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { RiUser4Line, RiLinkedinFill } from "react-icons/ri";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { BiLogoFacebook } from "react-icons/bi";
import { PiPhoneCall, PiInstagramLogoFill, PiYoutubeLogoFill } from "react-icons/pi";
import { MdAlternateEmail } from "react-icons/md";
import { GrLocation } from "react-icons/gr";
import { LuHeart } from "react-icons/lu";
import { FiArrowUpRight } from "react-icons/fi";
import PropertyBox from '../home/propertyBox';

import InnerBuilderBanner from "../../banner/innerBuilderBanner";
import esightLogo from '../../../assets/images/esight-logo-white.png'
import projectImg8 from '../../../assets/images/builders/builderProjects/img8.webp'

import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { useDispatch, useSelector } from "react-redux";
import { fetchWebsiteById } from "../../slice/websiteSlice";

const path = "/keralaplots/";
const Property_url="https://keralaplots.com/assets/images/PropertyImage/";
const BASE_URL_NOIMG = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.webp";
function InnerBuilders() {

     const { companyName } = useParams();
    const location = useLocation();

    const isActiveProjects = () => {
        return location.pathname.includes(`/builderProjectList`) || location.pathname.includes(`/builderProject`) ;
    };
    const isActiveProperty = () => {
        return location.pathname.includes(`/builderPropertyList`) || location.pathname.includes(`/builderProperty`) ;
    };

    // skelly loader
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {   
        localStorage.setItem("companyName", companyName);
    
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 300);
    
        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);
    

    // my propertyslider


    const carouselRef = useRef(null); // Reference for carousel

    const settings = {
        dots: false,
        loop: false,
        nav: false, // Disable default navigation
        margin: 20,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 },
        1200: { items: 4 },
        },
    };

    const settings1 = {
        dots: false,
        loop: true,
        nav: false, // Disable default navigation
        margin: 20,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
        0: { items: 1 },
        600: { items: 1 },
        1000: { items: 1 },
        1200: { items: 1 },
        },
    };

    // Custom Next & Prev Handlers
    const goToNext = () => {
        if (carouselRef.current) {
        carouselRef.current.next();
        }
    };

    const goToPrev = () => {
        if (carouselRef.current) {
        carouselRef.current.prev();
        }
    };

    const dispatch = useDispatch();
  const { testimonials, GalleryImages, websiteDetails, BannerImages, Properties, projects2, error } =
    useSelector((state) => state.website);
    useEffect(() => {
        if (companyName) {
          dispatch(fetchWebsiteById(companyName));
        }
      }, [dispatch, companyName]);

  
//       const [projects2, setProjects2] = useState([])

      
// const [testimonials,setTestimonials]=useState([]);
// const [GalleryImages,setGalleryImages]=useState([]);
// const [websiteDetails,setwebsiteDetails]=useState([]);
// const [BannerImages,setBannerImages]=useState([]); 
// const [Properties,setProperties]=useState([]);

// const fetch_websitet_by_id = async () => {
//        const cleanedCompanyName = decodeURIComponent(companyName);  
//        const login_id = localStorage.getItem('login_id');
//         try {
//         const response = await axios.post(`${baseURL}/website/fetch_websitet_by_id`, {
//             company_name: cleanedCompanyName,
//             login_id:login_id
//         });
//     console.log(response.data)
//     const tetstimonialdata = response.data.testimonials;
//     setTestimonials(
//         tetstimonialdata.map((testimonial) => ({
//             id: testimonial.id,
//             name: testimonial.name_val,
//             message: testimonial.message_val
//         }))
//     );

//     const galleryImages = response.data.galleryImages;
//             const gallerymageUrls = galleryImages.map(image => ({
//                 id: image.id,
//                 url: mediaUrl + image.gallery_images,
//                 isNew: false,
//             }));
//             setGalleryImages(gallerymageUrls);

//     const websiteDetails=response.data.websiteDetails[0];        
//     setwebsiteDetails({
//         company_name:websiteDetails.company_name,
//         logo_image:websiteDetails.logo_image,
//         phone1: websiteDetails.phone_number1,
//         phone2: websiteDetails.phone_number2,
//         email: websiteDetails.email_id,
//         address1:websiteDetails.address_line1,
//         address2:websiteDetails.address_line2,
//         address3:websiteDetails.address_line3,
//         facebook:websiteDetails.facebook_val,
//         instagram:websiteDetails.instagram_val,
//         youtube:websiteDetails.linkedin_val,
//         linkedin:websiteDetails.youtube_val,
//         title: websiteDetails.about_title,
//         experience: websiteDetails.experience_val,
//         description:websiteDetails.about_description,
//         });

//     const bannerImages = response.data.bannerImages;
//         const bannermageUrls = bannerImages.map(image => ({
//             id: image.id,
//             url: mediaUrl + image.banner_images,
//             isNew: false,
//         }));
//         setBannerImages(bannermageUrls);

//         setProperties(response.data.property.filter(properties => properties.checked === true));
//         setProjects2(response.data.projects.filter(project => project.checked === true));
//         setIsLoading(false);

//     }
//     catch (error) {
//         console.error(error);
//     }
// }


    // testimonials
    const [expandedIndex, setExpandedIndex] = useState(null);
    const [expandable, setExpandable] = useState([]);
    const textRefs = useRef({});

    useEffect(() => {
        setTimeout(() => {
            if (testimonials.length > 0) {
                const results = testimonials.map((_, index) => {
                    const ref = textRefs.current[index];
                    return ref && ref.scrollHeight > ref.clientHeight;
                });
                setExpandable(results);
            }
        }, 100);
    }, [testimonials]); // Run effect when testimonials change
    
    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

  return (
    <>
        <div className="navTemplate">
            <div className="container">
                <div className="navMain">
                    <div className="navCol1">
                        <a href={`${path}${companyName}`} className="navLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </a>    
                    </div>
                    <div className="navCol2">
                        <div className="navLink">
                            <ul>
                                <li>
                                    <NavLink to={`${path}${companyName}`} className={({ isActive }) => (isActive ? 'navLinkActive' : '')}>Home</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderProjectList`} className={() => (isActiveProjects() ? 'navLinkActive' : '')}>Projects</NavLink>
                                </li>
                                <li>
                                    <NavLink to={`${path}${companyName}/builderPropertyList`} className={() => (isActiveProperty() ? 'navLinkActive' : '')}>Properties</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="navCol3">
                        <div className="navProfile">
                            <NavLink to={`${path}`} target='_blank' className="navPostproperty">Kerala Plots <FiArrowUpRight /></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section id="innerBuilders">
            <div className="innerBuilderBanner">
                {isLoading ? (
                    <div className="bannerSkeletonLoader">
                        {Array.from({ length: 3 }).map((_, index) => (
                            <div key={index} className="innerBuilderBannerBox skeleton">
                                <Skeleton height={250} width="100%" />
                            </div>
                        ))}
                    </div>
                ) : BannerImages.length > 0 ? (  // Ensure images exist before rendering the carousel
                    <div className="carouselWrapper">
                        {/* Custom Prev Button */}
                        <button className="customNavBtn prev" onClick={goToPrev}>
                            <GoChevronLeft />
                        </button>

                        {/* Carousel */}
                        <OwlCarousel {...settings1} ref={carouselRef}>
                            {BannerImages.map((image) => (
                                <div key={image.id} className="innerBuilderBannerBox">
                                    <img src={image.url} alt="Banner" />
                                </div>
                            ))}
                        </OwlCarousel>

                        {/* Custom Next Button */}
                        <button className="customNavBtn next" onClick={goToNext}>
                            <GoChevronRight />
                        </button>
                    </div>
                ) : (
                    <p className="noDataMessage">No banners available.</p> // Fallback if there are no images
                )}
            </div>


            <div className="container">
                <div className="innerBuildersAbout">
                    <h1>{websiteDetails.title}</h1>
                    <p>{websiteDetails.description}</p>
                    <a href={`tel:+91${websiteDetails.phone1}`}>Contact Now</a>
                </div>
            </div>

            {projects2.length > 0 && (
            <div className="innerBuildersProjects" id='projectsList'>
                <div className="container">
                    <div className="innerBuildersProjectsHead">
                        <h2 className="title">Featured Projects</h2>
                    </div>
                    <div className="innerBuildersProjectsMain">
                        {isLoading ? (
                            <div className='SkeletonLoader'>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                            </div>
                        ) : (
                        <>
                        {projects2.map((project) => (
                                <a
                                key={project.id} // Assuming each project has a unique `project_id`
                                href={`${path}${companyName}/builderProject/${project.id}`} // Dynamically build the URL
                                className="innerBuildersProjectsBox"
                                >
                                <div className="innerBuildersProjectsBoxThumbnail">
                                    <img
                                    src={mediaUrl+project.image || projectImg8} // Use project-specific image or fallback image
                                    alt={project.project_name}
                                    />
                                    <div className="innerBuildersProjectsBoxTag">{project.project_status}</div>
                                </div>
                                <div className="innerBuildersProjectsBoxDetails">
                                    <h3>{project.project_name}</h3> {/* Display project name */}
                                    <p>{project.location_val}</p> {/* Display project location */}
                                </div>
                                </a>
                            ))}
                        </>
                    )}
                    </div>
                    <div className="loadMoreArea">
                        <a href={`${path}${companyName}/builderProjectList`} className="loadMoreBtn">View More</a>
                    </div>  
                </div>
            </div>
            )}

            {Properties.length > 0 && (
            <div className="innerBuildersProperty">
                <div className="container">
                    <div className="innerBuildersPropertyHead">
                        <h2 className="title">Explore Properties</h2>
                    </div>
                    <div className="innerBuildersPropertyList">
                        {isLoading ? (
                            <div className='SkeletonLoader'>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                                <div className='SkeletonLoaderBox'>
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                    <Skeleton />
                                    <Skeleton />
                                    <Skeleton />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <>
                            {Properties.map((property) => (
                            <PropertyBox 
                                propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '')+" for "+property.propertyAction}`}
                                propertyImage={property.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${property.imageName}` : BASE_URL_NOIMG}
                                propertyPurposeTag={property.propertyAction}
                                propertyId={property.propertyId}
                                propertyName={property.propertyType} 
                                propertyLocation={`${property.town}, ${property.district}`}
                                propertyDate="11-10-2024" 
                                propertyPrice={property.propertyPricerange}  
                                savedStatus={property.savedStatus}
                                addedId={property.loginId}
                            />
                        ))}
                            </>
                           
                        )}
                    </div>
                    <div className="loadMoreArea">
                        <a href={`${path}${companyName}/builderPropertyList`} className="loadMoreBtn">View More</a>
                    </div>
                </div>
            </div>
            )}  

        {testimonials.length > 0 && (
            <div className="innerBuildersTestimonials">
                <div className="container">
                    <div className="innerBuildersTestimonialsHead">
                        <h2 className="title">What our clients say</h2>
                    </div>
                    <div className="innerBuildersTestimonialsList">
                        <div className="carouselWrapper">
                            {/* Custom Prev Button */}
                            <button className="customNavBtn prev" onClick={goToPrev}>
                                <GoChevronLeft />
                            </button>

                            {/* Carousel */}
                            <OwlCarousel {...settings} ref={carouselRef}>
                                {testimonials.map((testimonial, index) => (
                                    <Suspense fallback={<p>Loading testimonial...</p>} key={testimonial.id}>
                                    <div className="innerBuildersTestimonialsBox">
                                        <div className="iconLeft">
                                            <FaQuoteLeft />
                                        </div>
                                        {/* <p>{testimonial.message}</p> */}
                                        <p 
                                            ref={(el) => (textRefs.current[index] = el)}
                                            className={expandedIndex === index ? "expandedText" : "collapsedText"}
                                        >
                                            {testimonial.message}
                                        </p>
                                        {expandable[index] && (
                                            <button className="toggleButton" onClick={() => toggleExpand(index)}>
                                                {expandedIndex === index ? "Shrink" : "Expand"}
                                            </button>
                                        )}
                                        <div className="iconRight">
                                        <FaQuoteRight />
                                        </div>
                                        <div className="innerBuildersTestimonialsBoxProfile">
                                            <div className="innerBuildersTestimonialsBoxProfileImg">
                                                <RiUser4Line />
                                            </div>
                                            <h3>{testimonial.name}</h3>
                                        </div>
                                    </div>
                                    </Suspense>
                                ))}
                            </OwlCarousel>

                            {/* Custom Next Button */}
                            <button className="customNavBtn next" onClick={goToNext}>
                                <GoChevronRight />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )}

            <PhotoProvider>
                <div className="innerBuildersGallery">
                {GalleryImages.map((gallery, index) => (
                    <div key={gallery.id || index} className="innerBuildersGalleryBox">
                        <PhotoView src={gallery.url}>
                        <img src={gallery.url} alt={`Gallery image ${index + 1}`} />
                        </PhotoView>
                    </div>
                    ))}
                </div>
            </PhotoProvider>
        </section>
        <div className="footerTemplate">
            <div className="container">
                <div className="footerMain">
                    <div className="footerBox1">
                        <div className="footerLogo">
                        {websiteDetails.logo_image ? (
                                <img src={mediaUrl + websiteDetails.logo_image} alt="Website Logo" />
                            ) : (
                                <Skeleton width={100} height={50} /> // Placeholder loading effect
                            )}
                        </div>
                        <div className='footerSocialLink'>
                            <Link to={websiteDetails.facebook} target='_blank' className='footerSocialLinkBox'>
                                <BiLogoFacebook />
                            </Link>
                            <Link to={websiteDetails.instagram} target='_blank' className='footerSocialLinkBox'>
                                <PiInstagramLogoFill />
                            </Link>
                            <Link to={websiteDetails.linkedin} target='_blank' className='footerSocialLinkBox'>
                                <RiLinkedinFill />
                            </Link>
                            <Link to={websiteDetails.youtube} target='_blank' className='footerSocialLinkBox'>
                                <PiYoutubeLogoFill />
                            </Link>
                        </div>
                    </div>
                    <div className="footerBox2">
                        <h2>Links</h2>
                        <ul>
                            <li>
                                <NavLink to={`${path}${companyName}`}><span></span>Home</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderProjectList`}><span></span>Projects</NavLink>
                            </li>
                            <li>
                                <NavLink to={`${path}${companyName}/builderPropertyList`}><span></span>Properties</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="footerBox3">
                        <h2>Connect Us</h2>
                        <ul>
                            <li>
                                <div className='icon'>
                                    <PiPhoneCall />
                                </div>
                                <div className='contactDestails'>
                                    <Link to={`tel:+91${websiteDetails.phone1}`}>+91 {websiteDetails.phone1}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <MdAlternateEmail />
                                </div>
                                <div className='contactDestails'>
                                    <Link to={`mailto:${websiteDetails.email}`}>{websiteDetails.email}</Link>
                                </div>
                            </li>
                            <li>
                                <div className='icon'>
                                    <GrLocation />
                                </div>
                                <div className='contactDestails'>
                                    <p>{websiteDetails.address1} <br/>{websiteDetails.address2}<br/>{websiteDetails.address3}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='footerStrip'>
                    <div className='footerStripBox'>
                        <p>Copyright © {new Date().getFullYear()} keralaplots. All Rights Reserved.</p>
                    </div>
                    <div className='footerStripBox'>
                        <p>Designed with</p>
                        <LuHeart />
                        <Link to="https://esightsolutions.com/" target='_blank' className='footerStripLogo'>
                            <img src={esightLogo} alt="" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </>
  );
}

export default InnerBuilders;
